export function mapGetProductsToResponse(products: any): any {
  return products;
}

export function mapGetProductToResponse(product: any): any {
  return product;
}
